import { FC, ReactNode } from 'react'
import Link from 'next/link'

interface ArticleCategoryChipProps {
	href: string
	children: ReactNode
}

const ArticleCategoryChip: FC<ArticleCategoryChipProps> = ({
	href,
	children,
}) => {
	return (
		<Link href={href} className="article-category-chip">
			{children}
		</Link>
	)
}

export default ArticleCategoryChip

